import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { selectors, actions, CurrentBusiness, LabExample } from "../../../reducers/lab";
import { useUser, useIsAuthed } from "../../../auth";
import axios from "axios";
import { UserProfileInterface } from "../UserProfile/UserProfile";
import "./UserDropDown.styles.scss";

interface UserDropDownInterface {
	currentBusiness?: CurrentBusiness;
	selectedExample?: LabExample;
	setCurrentBusiness?(currentBusiness: CurrentBusiness);
	changeExampleData?(exampleData: any);
}

interface UserBusinessesInterface {
	items: [
		{
			id: string;
			displayName: string;
		},
	];
}

const UserDropDown = (props: UserDropDownInterface) => {
	const [userProfile, setUserProfile] = useState<UserProfileInterface>();
	const [userBusinesses, setUserBusinesses] = useState<UserBusinessesInterface>();
	const [isOpen, setIsOpen] = React.useState(false);
	const isAuth = useIsAuthed();
	const user = useUser();
	const ref = useRef(null);
	const { currentBusiness, setCurrentBusiness, selectedExample, changeExampleData } = props;

	const getUserBusinesses = async () => {
		const meRes = await axios.get("/me/businesses?roles=true", {
			baseURL: process.env.STUDIO_API_URL,
			headers: { authorization: `Bearer ${user.access_token}` },
		});
		setUserBusinesses(meRes.data);
		if (!currentBusiness) {
			setCurrentBusiness({
				businessId: user.profile.default_business_id,
				displayName: user.profile.name,
			});
		}
	};

	const changeUserBusiness = (businessId: string, displayName: string) => {
		setCurrentBusiness({
			businessId: businessId,
			displayName: displayName,
		});
		
		if (selectedExample) {
			let exampleUrl = selectedExample.data.request.url
			userBusinesses.items.map(userBusiness => {
				if (exampleUrl.includes(userBusiness.id)) {
					changeExampleData({
						...selectedExample.data,
						request: {
							...selectedExample.data.request,
							url: exampleUrl.replace(userBusiness.id, businessId)
						}
					})
				}
			})
		}
		setIsOpen(!isOpen);
	};

	useEffect(() => {
		if (!isAuth) return;
		if (user) {
			getUserBusinesses();
			setUserProfile(user.profile);
		}
		function handleClickOutside(event) {
			if (ref.current && !ref.current.contains(event.target)) {
				setIsOpen(!isOpen);
			}
		}
		if (isOpen) {
			document.addEventListener("mousedown", handleClickOutside);
		} else {
			document.removeEventListener("mousedown", handleClickOutside);
		}
	}, [isAuth, user, ref, isOpen]);

	return (
		<>
			{userProfile ? (
				<div className="user-dropdown" ref={ref}>
					<h4
						title={currentBusiness ? currentBusiness.displayName : userProfile.name}
						onClick={() => setIsOpen(!isOpen)}
					>
						{currentBusiness ? currentBusiness.displayName : userProfile.name}
						<span
							className="arrow"
							style={isOpen ? { transform: "translateY(-50%) rotate(180deg)" } : {}}
						>
							<i className="fa-regular fa-chevron-down"></i>
						</span>
					</h4>
					<div className="user-profile-dropdown" style={{ display: isOpen ? "flex" : "none" }}>
						{userBusinesses
							? userBusinesses.items.map(({ id, displayName }) => {
									const selectedClass = currentBusiness
										? currentBusiness.businessId === id
											? "selected"
											: ""
										: "";
									return (
										<p
											key={id}
											onClick={() => changeUserBusiness(id, displayName)}
											className={selectedClass}
										>
											{displayName}
										</p>
									);
							  })
							: null}
					</div>
				</div>
			) : null}
		</>
	);
};

const mapStateToProps = (state) => ({
	currentBusiness: selectors.selectCurrentBusiness(state),
	selectedExample: selectors.selectExample(state),
});

const mapDispatchToProps = {
	setCurrentBusiness: actions.setCurrentBusiness,
	changeExampleData: actions.changeExampleData,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserDropDown);
